module.exports = __webpack_public_path__ + "img/dwn_red_new.68486de2.svg";